"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcSearchBehavior = void 0;
var default_behavior_1 = require("../../../common/models/default-behavior");
var common_constants_1 = require("../../../common/constants/common-constants");
var helpers_1 = require("../../../common/helpers");
var bc_input_select_behavior_1 = require("../../molecules/bc-input-select/bc-input-select-behavior");
var bc_input_behavior_1 = require("../../atoms/bc-input/bc-input-behavior");
var bc_search_constants_1 = require("./bc-search-constants");
var bc_search_constants_2 = require("./bc-search-constants");
var bc_search_constants_3 = require("./bc-search-constants");
var bc_search_constants_4 = require("./bc-search-constants");
var bc_search_constants_5 = require("./bc-search-constants");
var bc_search_constants_6 = require("./bc-search-constants");
var bc_search_constants_7 = require("./bc-search-constants");
var bc_search_constants_8 = require("./bc-search-constants");
var bc_search_constants_9 = require("./bc-search-constants");
var bc_search_constants_10 = require("./bc-search-constants");
var bc_search_constants_11 = require("./bc-search-constants");
var bc_search_constants_12 = require("./bc-search-constants");
var bc_search_constants_13 = require("./bc-search-constants");
var bc_search_constants_14 = require("./bc-search-constants");
var bc_search_constants_15 = require("./bc-search-constants");
var bc_search_constants_16 = require("./bc-search-constants");
var bc_search_constants_17 = require("./bc-search-constants");
var bc_search_constants_18 = require("./bc-search-constants");
var bc_search_constants_19 = require("./bc-search-constants");
var bc_search_constants_20 = require("./bc-search-constants");
var bc_search_constants_21 = require("./bc-search-constants");
var bc_search_constants_22 = require("./bc-search-constants");
var bc_input_date_behavior_1 = require("../bc-calendar/bc-input-date-behavior");
var bc_input_date_range_behavior_1 = require("../bc-calendar/bc-input-date-range-behavior");
var bc_input_file_constants_1 = require("../bc-input-file/bc-input-file-constants");
var bc_input_number_behavior_1 = require("../../molecules/bc-input-number/bc-input-number-behavior");
var BcSearchBehavior = (function (_super) {
    __extends(BcSearchBehavior, _super);
    function BcSearchBehavior() {
        var _this = _super.call(this) || this;
        _this.resultFilter = [];
        _this.inputsContentsMemory = [];
        _this.jsObjt = {};
        _this.jsDates = {};
        _this.jsRangeData = {};
        _this.jsSelectMultiple = {};
        _this.keyObjtValue = {};
        _this.objectArrayItem = [];
        _this.stringFilters = '';
        return _this;
    }
    BcSearchBehavior.prototype.setItems = function (value) {
        this.objectArrayItem = value;
    };
    BcSearchBehavior.prototype._setUp = function () {
        this.setInputsObjectSearch(bc_input_file_constants_1.ZERO_NUMBER);
        this.setListenerButtonSearchClick();
        this.toggleDropDownAdvancedSearch();
        this.toggleKeyAdvancedSearch();
        this.setInputSelectInSearch();
        this.clearSearch();
        this.initInputBehavior();
        this.closeAdvancedSearch();
        this.hideElements();
        (0, helpers_1.addFocusable)(this.mySelf);
    };
    BcSearchBehavior.prototype.toggleDropDownAdvancedSearch = function () {
        var _this = this;
        var dropDown = this.mySelf.querySelector("".concat(common_constants_1.BcCommonConstants.DIV_TAG, "[class^=\"").concat(bc_search_constants_1.SEARCH_ARROW_CLASS, "\"]"));
        var contentAdvanceSearch = this.mySelf.querySelector(".".concat(bc_search_constants_18.SEARCH_ADVANCED_CLASS));
        var iconDropDown = this.mySelf.querySelector(".".concat(bc_search_constants_1.SEARCH_ARROW_CLASS, " .").concat(common_constants_1.BcCommonConstants.ICONS_CLASS));
        dropDown.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function () {
            if (contentAdvanceSearch.classList.contains("".concat(bc_search_constants_9.SEARCH_ADVANCED_ACTIVE_CLASS))) {
                contentAdvanceSearch.classList.remove("".concat(bc_search_constants_9.SEARCH_ADVANCED_ACTIVE_CLASS));
                iconDropDown.textContent = common_constants_1.BcCommonConstants.ICON_ARROW_DOWN;
            }
            else {
                _this.openAdvancedSearch();
            }
        });
    };
    BcSearchBehavior.prototype.toggleKeyAdvancedSearch = function () {
        var _this = this;
        var dropDown = this.mySelf.querySelector("".concat(common_constants_1.BcCommonConstants.DIV_TAG, "[class^=\"").concat(bc_search_constants_1.SEARCH_ARROW_CLASS, "\"]"));
        var contentAdvanceSearch = this.mySelf.querySelector(".".concat(bc_search_constants_18.SEARCH_ADVANCED_CLASS));
        var iconDropDown = this.mySelf.querySelector(".".concat(bc_search_constants_1.SEARCH_ARROW_CLASS, " .").concat(common_constants_1.BcCommonConstants.ICONS_CLASS));
        dropDown.addEventListener(common_constants_1.BcCommonConstants.EVENT_KEY_DOWN, function (event) {
            if (event.key === common_constants_1.BcCommonConstants.KEY_EVENT_ENTER || event.code === common_constants_1.BcCommonConstants.KEY_EVENT_SPACE) {
                if (contentAdvanceSearch.classList.contains("".concat(bc_search_constants_9.SEARCH_ADVANCED_ACTIVE_CLASS))) {
                    contentAdvanceSearch.classList.remove("".concat(bc_search_constants_9.SEARCH_ADVANCED_ACTIVE_CLASS));
                    iconDropDown.textContent = common_constants_1.BcCommonConstants.ICON_ARROW_DOWN;
                }
                else {
                    _this.openAdvancedSearch();
                }
            }
        });
    };
    BcSearchBehavior.prototype.openAdvancedSearch = function () {
        var contentAdvanceSearch = this.mySelf.querySelector(".".concat(bc_search_constants_18.SEARCH_ADVANCED_CLASS));
        var iconDropDown = this.mySelf.querySelector(".".concat(bc_search_constants_1.SEARCH_ARROW_CLASS, " .").concat(common_constants_1.BcCommonConstants.ICONS_CLASS));
        contentAdvanceSearch.classList.add("".concat(bc_search_constants_9.SEARCH_ADVANCED_ACTIVE_CLASS));
        iconDropDown.textContent = common_constants_1.BcCommonConstants.ICON_ARROW_UP;
    };
    BcSearchBehavior.prototype.closeAdvancedSearch = function () {
        var contentAdvanceSearch = this.mySelf.querySelector(".".concat(bc_search_constants_18.SEARCH_ADVANCED_CLASS));
        var iconDropDown = this.mySelf.querySelector(".".concat(bc_search_constants_1.SEARCH_ARROW_CLASS, " .").concat(common_constants_1.BcCommonConstants.ICONS_CLASS));
        window.addEventListener(common_constants_1.BcCommonConstants.EVENT_KEY_DOWN, function (event) {
            if (event.key === common_constants_1.BcCommonConstants.KEY_EVENT_ESCAPE) {
                contentAdvanceSearch.classList.remove("".concat(bc_search_constants_9.SEARCH_ADVANCED_ACTIVE_CLASS));
                iconDropDown.textContent = common_constants_1.BcCommonConstants.ICON_ARROW_DOWN;
            }
        });
        document.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function (event) {
            if (!event.target.closest(".".concat(bc_search_constants_20.SEARCH_CLASS)) &&
                contentAdvanceSearch.classList.contains("".concat(bc_search_constants_9.SEARCH_ADVANCED_ACTIVE_CLASS))) {
                contentAdvanceSearch.classList.remove("".concat(bc_search_constants_9.SEARCH_ADVANCED_ACTIVE_CLASS));
                iconDropDown.textContent = common_constants_1.BcCommonConstants.ICON_ARROW_DOWN;
            }
        });
    };
    BcSearchBehavior.prototype.setListenerButtonSearchClick = function () {
        var _this = this;
        var input = this.mySelf.querySelectorAll(".".concat(bc_search_constants_10.SEARCH_BUTTON_CLASS));
        for (var _i = 0, input_1 = input; _i < input_1.length; _i++) {
            var inputValues = input_1[_i];
            inputValues.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function () { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    this.searchObject();
                    return [2];
                });
            }); });
        }
    };
    BcSearchBehavior.prototype.searchObject = function () {
        return __awaiter(this, void 0, void 0, function () {
            var inputValue, bandButton;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        inputValue = this.mySelf.querySelectorAll(common_constants_1.BcCommonConstants.INPUT_TAG);
                        bandButton = false;
                        this.stringFilters = '';
                        this.jsObjt = {};
                        this.jsDates = {};
                        this.jsRangeData = {};
                        this.jsSelectMultiple = {};
                        bandButton = this.searchObjectIterate(inputValue, bandButton);
                        this.resultFilter = [];
                        this.query = __assign(__assign(__assign(__assign({}, this.jsObjt), this.jsDates), this.jsRangeData), this.jsSelectMultiple);
                        if (!this.preSearchFunction) return [3, 2];
                        return [4, this.preSearchFunction(this.query)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        this.verifyAndSearchDataInputs();
                        this.verifyOutputFuctionSearch(this.resultFilter);
                        this.verifyContentInObjectResult();
                        this.enableOrDisableButtonSearch(bandButton);
                        this.setValueInput(this.jsObjt);
                        return [2];
                }
            });
        });
    };
    BcSearchBehavior.prototype.filterResults = function (objectArrayItem, resultFilter) {
        return objectArrayItem.filter(function (element) { return !resultFilter.includes(element); });
    };
    BcSearchBehavior.prototype.hasDateInputs = function (jsDates, objectArrayItem) {
        return jsDates.length > bc_input_file_constants_1.ZERO_NUMBER && objectArrayItem.length > bc_input_file_constants_1.ZERO_NUMBER;
    };
    BcSearchBehavior.prototype.hasTextInputs = function (jsObjt, objectArrayItem) {
        return jsObjt.length > bc_input_file_constants_1.ZERO_NUMBER && objectArrayItem.length > bc_input_file_constants_1.ZERO_NUMBER;
    };
    BcSearchBehavior.prototype.hasRangeDataInputs = function (jsRangeData, objectArrayItem) {
        return jsRangeData.length > bc_input_file_constants_1.ZERO_NUMBER && objectArrayItem.length > bc_input_file_constants_1.ZERO_NUMBER;
    };
    BcSearchBehavior.prototype.hasSelectMultipleInputs = function (jsSelectMultiple, objectArrayItem) {
        return jsSelectMultiple.length > bc_input_file_constants_1.ZERO_NUMBER && objectArrayItem.length > bc_input_file_constants_1.ZERO_NUMBER;
    };
    BcSearchBehavior.prototype.verifyAndSearchDataInputs = function () {
        if (this.hasDateInputs(Object.keys(this.jsDates), this.objectArrayItem)) {
            for (var _i = 0, _a = this.objectArrayItem; _i < _a.length; _i++) {
                var value = _a[_i];
                this.dataDateSearch(value);
            }
        }
        if (this.hasRangeDataInputs(Object.keys(this.jsRangeData), this.objectArrayItem)) {
            for (var _b = 0, _c = this.objectArrayItem; _b < _c.length; _b++) {
                var value = _c[_b];
                this.dataRangeSearch(value);
            }
        }
        if (this.hasSelectMultipleInputs(Object.keys(this.jsSelectMultiple), this.objectArrayItem)) {
            for (var _d = 0, _e = this.objectArrayItem; _d < _e.length; _d++) {
                var value = _e[_d];
                this.dataSelectMultipleSearch(value);
            }
        }
        if (this.hasTextInputs(Object.keys(this.jsObjt), this.objectArrayItem)) {
            var resultTextFilters = [];
            for (var _f = 0, _g = this.objectArrayItem; _f < _g.length; _f++) {
                var value = _g[_f];
                var responseFilter = this.dataSearch(value, this.jsObjt);
                if (responseFilter) {
                    resultTextFilters.push(value);
                }
            }
            this.resultFilter = this.filterResults(resultTextFilters, this.resultFilter);
        }
    };
    BcSearchBehavior.prototype.dataDateSearch = function (data) {
        var _this = this;
        var keys = Object.keys(this.jsDates);
        keys.forEach(function (key) {
            var ValueKey = Object.getOwnPropertyDescriptor(data, key);
            if (ValueKey) {
                var date1String = _this.jsDates[key].date1;
                var date2String = _this.jsDates[key].date2;
                if (_this.pushDateIfIsInRange(ValueKey.value, date1String, date2String)) {
                    _this.resultFilter.push(data);
                }
            }
        });
    };
    BcSearchBehavior.prototype.pushDateIfIsInRange = function (validateDate, minDate, Maxdate) {
        var dateValue = new Date(validateDate);
        var date1 = new Date(minDate);
        var date2 = new Date(Maxdate);
        if (dateValue >= date1 && dateValue <= date2) {
            return true;
        }
        return false;
    };
    BcSearchBehavior.prototype.dataRangeSearch = function (data) {
        var _this = this;
        var keys = Object.keys(this.jsRangeData);
        keys.forEach(function (key) {
            var ValueKey = Object.getOwnPropertyDescriptor(data, key);
            if (ValueKey) {
                var minRangeString = _this.jsRangeData[key].min;
                var maxRangeString = _this.jsRangeData[key].max;
                if ((!!minRangeString && !!maxRangeString) && _this.pushDataIfIsInRange(ValueKey.value, minRangeString, maxRangeString)) {
                    _this.resultFilter.push(data);
                }
            }
        });
    };
    BcSearchBehavior.prototype.dataSelectMultipleSearch = function (data) {
        var _this = this;
        var keys = Object.keys(this.jsSelectMultiple);
        keys.forEach(function (key) {
            var ValueData = Object.getOwnPropertyDescriptor(data, key);
            if (ValueData) {
                var selectMultiple = _this.jsSelectMultiple[key];
                if (!!selectMultiple && _this.pushDataIfisInSelectMultiple(ValueData.value, selectMultiple)) {
                    _this.resultFilter.push(data);
                }
            }
        });
    };
    BcSearchBehavior.prototype.pushDataIfisInSelectMultiple = function (valueData, selectMultiple) {
        return selectMultiple.find(function (value) { return value !== valueData; });
    };
    BcSearchBehavior.prototype.pushDataIfIsInRange = function (validateData, minRangeString, maxRangeString) {
        var dataValue = Number(validateData);
        var minRange = Number(minRangeString);
        var maxRange = Number(maxRangeString);
        return dataValue >= minRange && dataValue <= maxRange;
    };
    BcSearchBehavior.prototype.verifyOutputFuctionSearch = function (resultFilter) {
        var result = {
            result: resultFilter,
            query: __assign(__assign(__assign(__assign({}, this.jsObjt), this.jsDates), this.jsRangeData), this.jsSelectMultiple)
        };
        if (this.outputFunction) {
            this.outputFunction(result);
            this.verifyContentInObjectResult();
        }
    };
    BcSearchBehavior.prototype.verifyContentInObjectResult = function () {
        var clearSelector = this.mySelf.querySelector(".".concat(bc_search_constants_14.SEARCH_CLEAR_CLASS));
        var result = this.mySelf.querySelector(".".concat(bc_search_constants_12.SEARCH_CONTENT_SHOW_RESULT_CLASS));
        var divAttributes = this.mySelf.querySelectorAll(".".concat(bc_search_constants_15.SEARCH_RESULT_NULL_CLASS, " ").concat(common_constants_1.BcCommonConstants.DIV_TAG));
        if (Object.keys(this.jsObjt).length > bc_search_constants_21.SEARCH_NUMBER_ZERO || Object.keys(this.jsDates).length > bc_search_constants_21.SEARCH_NUMBER_ZERO || Object.keys(this.jsRangeData).length > bc_search_constants_21.SEARCH_NUMBER_ZERO || Object.keys(this.jsSelectMultiple).length > bc_search_constants_21.SEARCH_NUMBER_ZERO) {
            this.showQuantityItems(this.resultFilter.length);
        }
        else {
            clearSelector.classList.remove("".concat(bc_search_constants_16.SEARCH_CLEAR_SHOW_CLASS));
            while (result.firstChild) {
                result.removeChild(result.firstChild);
            }
            this.removeDivAttributeImage(divAttributes);
        }
    };
    BcSearchBehavior.prototype.removeDivAttributeImage = function (divAttributes) {
        for (var _i = 0, divAttributes_1 = divAttributes; _i < divAttributes_1.length; _i++) {
            var divAttribute = divAttributes_1[_i];
            divAttribute.classList.remove("".concat(bc_search_constants_17.SEARCH_SHOW_IMAGE_CLASS));
        }
    };
    BcSearchBehavior.prototype.enableOrDisableButtonSearch = function (bandButton) {
        var buttonSearch = this.mySelf.querySelector(".".concat(bc_search_constants_10.SEARCH_BUTTON_CLASS, " ").concat(common_constants_1.BcCommonConstants.BUTTON_TAG));
        if (!!buttonSearch) {
            if (bandButton) {
                buttonSearch.disabled = common_constants_1.BcCommonConstants.FALSE;
            }
            else {
                buttonSearch.disabled = common_constants_1.BcCommonConstants.TRUE;
            }
        }
    };
    BcSearchBehavior.prototype.searchObjectIterate = function (inputValue, bandButton) {
        var booleanbutton = bandButton;
        for (var _i = 0, inputValue_1 = inputValue; _i < inputValue_1.length; _i++) {
            var inputValues = inputValue_1[_i];
            if (!(inputValues.type === bc_search_constants_8.SEARCH_INPUT_CHECKBOX && inputValues.className === "".concat(bc_search_constants_1.SEARCH_INPUT_SELECT_MULTIPLE_ITEM_CLASS))) {
                if (inputValues.type === bc_search_constants_8.SEARCH_INPUT_CHECKBOX) {
                    this.verifyCheckedInputsAndPushedData(inputValues);
                }
                else {
                    this.verifyValuesInputsAndPushedData(inputValues);
                }
            }
            if (this.stringFilters) {
                booleanbutton = common_constants_1.BcCommonConstants.TRUE;
            }
        }
        return booleanbutton;
    };
    BcSearchBehavior.prototype.verifyCheckedInputsAndPushedData = function (inputValues) {
        if (inputValues.checked) {
            if (this.jsObjt.hasOwnProperty(inputValues.name)) {
                this.jsObjt[inputValues.name].push(inputValues.value);
                this.stringFilters += inputValues.value + ',';
            }
            else {
                this.jsObjt[inputValues.name] = [];
                this.jsObjt[inputValues.name].push(inputValues.value);
                this.stringFilters += inputValues.value + ',';
            }
        }
    };
    BcSearchBehavior.prototype.verifyValuesInputsAndPushedData = function (inputValues) {
        if (inputValues.value) {
            this.validateHasInputs(inputValues);
        }
    };
    BcSearchBehavior.prototype.validateHasInputs = function (inputValues) {
        if (inputValues.hasAttribute('dateType')) {
            this.findDateRangeValues(inputValues);
        }
        else if (inputValues.hasAttribute('rangeType')) {
            this.findDataRangeValues(inputValues);
        }
        else if (this.validateHasSelectInput(inputValues)) {
            if (inputValues.parentElement.hasAttribute('multiple')) {
                this.findInputSelectMultipleValues(inputValues);
            }
            else {
                this.findInputSelectValues(inputValues);
            }
        }
        else {
            this.findDataObjectValues(inputValues);
        }
    };
    BcSearchBehavior.prototype.validateHasSelectInput = function (inputValues) {
        return inputValues.parentElement.classList.contains("".concat(bc_search_constants_11.SEARCH_INPUT_SELECT_CLASS)) || inputValues.parentElement.classList.contains('bc-input-select-active');
    };
    BcSearchBehavior.prototype.findInputSelectValues = function (inputValues) {
        var value = this.setDataSelect[inputValues.parentElement.id].value;
        this.jsObjt[inputValues.name] = value;
        if (inputValues.dataset.value) {
            this.jsObjt[inputValues.dataset.value] = value;
        }
        this.stringFilters += inputValues.value + ',';
    };
    BcSearchBehavior.prototype.findInputSelectMultipleValues = function (inputValues) {
        var value = this.setDataSelect[inputValues.parentElement.id].value;
        this.jsSelectMultiple[inputValues.name] = value;
        this.stringFilters += value + ',';
    };
    BcSearchBehavior.prototype.findDateRangeValues = function (inputValues) {
        if (this.jsDates[inputValues.name] === undefined) {
            this.jsDates[inputValues.name] = { date1: inputValues.value, date2: '' };
        }
        else {
            this.jsDates[inputValues.name].date2 = inputValues.value;
        }
        this.stringFilters += inputValues.value + ',';
    };
    BcSearchBehavior.prototype.findDataRangeValues = function (inputValues) {
        if (!this.jsRangeData[inputValues.name]) {
            this.jsRangeData[inputValues.name] = { min: inputValues.value, max: '' };
        }
        else {
            this.jsRangeData[inputValues.name].max = inputValues.value;
        }
        this.stringFilters += inputValues.value + ',';
    };
    BcSearchBehavior.prototype.findDataObjectValues = function (inputValues) {
        if (!this.validateHasSelectInput(inputValues)) {
            this.jsObjt[inputValues.name] = inputValues.value;
            if (inputValues.dataset.value) {
                this.jsObjt[inputValues.dataset.value] = inputValues.value;
            }
            this.stringFilters += inputValues.value + ',';
        }
    };
    BcSearchBehavior.prototype.setInputsObjectSearch = function (timeEject) {
        var inputs = this.mySelf.querySelectorAll(common_constants_1.BcCommonConstants.INPUT_TAG);
        var inputSelects = this.mySelf.querySelectorAll(".".concat(bc_search_constants_11.SEARCH_INPUT_SELECT_CLASS));
        var inputDates = this.mySelf.querySelectorAll(".".concat(bc_search_constants_13.SEARCH_INPUT_DATE_CLASS));
        var inputDatesRange = this.mySelf.querySelectorAll(".".concat(bc_search_constants_1.SEARCH_INPUT_DATE_RANGE_CLASS));
        var inputDataRange = this.mySelf.querySelectorAll(".".concat(bc_search_constants_1.SEARCH_INPUT_DATA_RANGE_CLASS));
        this.createInputDate(inputDates);
        this.createInputDateRange(inputDatesRange);
        this.createInputDataRange(inputDataRange);
        this.createInputSelect(inputSelects);
        this.listenerElementInput(inputs, timeEject);
    };
    BcSearchBehavior.prototype.createInputDate = function (inputDates) {
        var _this = this;
        var _loop_1 = function (inputDate) {
            setTimeout(function () {
                var inputDateComponent = new bc_input_date_behavior_1.BcInputDateBehavior();
                var inputDateId = false;
                if (!!_this.setIdDates) {
                    inputDateId = _this.setIdDates.id.includes(inputDate.id);
                }
                if (!!inputDate.id && inputDateId) {
                    inputDateComponent.setElement(inputDate);
                    inputDateComponent.output = function () {
                        _this.searchObject();
                    };
                    inputDateComponent.setUp();
                }
            }, bc_search_constants_21.SEARCH_NUMBER_ZERO);
        };
        for (var _i = 0, inputDates_1 = inputDates; _i < inputDates_1.length; _i++) {
            var inputDate = inputDates_1[_i];
            _loop_1(inputDate);
        }
    };
    BcSearchBehavior.prototype.createInputDateRange = function (inputDates) {
        var _this = this;
        var _loop_2 = function (inputDate) {
            setTimeout(function () {
                var inputDateRangeComponent = new bc_input_date_range_behavior_1.BcInputDateRangeBehavior();
                var inputDateId = false;
                if (!!_this.setIdDatesRange) {
                    inputDateId = _this.setIdDatesRange.id.includes(inputDate.id);
                }
                if (!!inputDate.id && inputDateId) {
                    inputDateRangeComponent.setElement(inputDate);
                    inputDateRangeComponent.output = function () {
                        _this.searchObject();
                    };
                    inputDateRangeComponent.setUp();
                }
            }, bc_search_constants_21.SEARCH_NUMBER_ZERO);
        };
        for (var _i = 0, inputDates_2 = inputDates; _i < inputDates_2.length; _i++) {
            var inputDate = inputDates_2[_i];
            _loop_2(inputDate);
        }
    };
    BcSearchBehavior.prototype.createInputDataRange = function (inputDataRange) {
        var _this = this;
        var _loop_3 = function (inputData) {
            setTimeout(function () {
                var inputDataRangeComponent = new bc_input_number_behavior_1.BcInputNumberBehavior();
                var inputDataId = _this.setIdDataRange[inputDataRange.id];
                if (!!inputDataId) {
                    inputDataRangeComponent.setElement(inputData);
                    inputDataRangeComponent.output = function () {
                        _this.searchObject();
                    };
                    inputDataRangeComponent.setUp();
                }
            }, bc_search_constants_21.SEARCH_NUMBER_ZERO);
        };
        for (var _i = 0, inputDataRange_1 = inputDataRange; _i < inputDataRange_1.length; _i++) {
            var inputData = inputDataRange_1[_i];
            _loop_3(inputData);
        }
    };
    BcSearchBehavior.prototype.createInputSelect = function (inputSelects) {
        var _this = this;
        var _loop_4 = function (inputSelect) {
            setTimeout(function () {
                var selectComponent = new bc_input_select_behavior_1.BcInputSelectBehavior();
                var inputSelectId = _this.setDataSelect[inputSelect.id];
                if (!!inputSelectId) {
                    selectComponent.setElement(inputSelect);
                    selectComponent.setItems(inputSelectId.items);
                    selectComponent.outputFunction = function (data) {
                        _this.setDataSelect[inputSelect.id].value = data;
                        _this.setDataSelect[inputSelect.id].typeSelect = bc_search_constants_19.SEARCH_INPUT_SELECT;
                        _this.searchObject();
                    };
                    selectComponent.setUp();
                }
            }, bc_search_constants_21.SEARCH_NUMBER_ZERO);
        };
        for (var _i = 0, inputSelects_1 = inputSelects; _i < inputSelects_1.length; _i++) {
            var inputSelect = inputSelects_1[_i];
            _loop_4(inputSelect);
        }
    };
    BcSearchBehavior.prototype.listenerElementInput = function (inputs, timeEject) {
        var _this = this;
        for (var _i = 0, inputs_1 = inputs; _i < inputs_1.length; _i++) {
            var input = inputs_1[_i];
            input.addEventListener(common_constants_1.BcCommonConstants.EVENT_INPUT, this.debounce(function () {
                _this.searchObject();
            }, timeEject || bc_search_constants_5.SEARCH_NUMBER_FIVE_HUNDRED));
        }
    };
    BcSearchBehavior.prototype.debounce = function (callback, wait) {
        var timerId;
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            clearTimeout(timerId);
            timerId = setTimeout(function () {
                callback.apply(void 0, args);
            }, wait);
        };
    };
    BcSearchBehavior.prototype.setInputsElementSelect = function (setData) {
        this.setDataSelect = setData;
    };
    BcSearchBehavior.prototype.setInputsDateId = function (setId) {
        this.setIdDates = setId;
    };
    BcSearchBehavior.prototype.setInputsDateRangeId = function (setId) {
        this.setIdDatesRange = setId;
    };
    BcSearchBehavior.prototype.setInputsDataRangeId = function (setId) {
        this.setIdDataRange = setId;
    };
    BcSearchBehavior.prototype.dataSearch = function (user, filter) {
        var _this = this;
        var booleanResult = common_constants_1.BcCommonConstants.FALSE;
        var keys = Object.keys(filter);
        keys.forEach(function (key) {
            var _a;
            if ((_a = filter[key]) === null || _a === void 0 ? void 0 : _a.length) {
                booleanResult = _this.verifyFilterSearchReturn(filter, key, user, booleanResult);
            }
        });
        return booleanResult;
    };
    BcSearchBehavior.prototype.verifyFilterSearchReturn = function (filter, key, user, booleanResult) {
        booleanResult = this.dataSearchIsNotArray(key, booleanResult, user, filter);
        return booleanResult;
    };
    BcSearchBehavior.prototype.dataSearchIsNotArray = function (key, booleanResult, user, filter) {
        var objData = this.mySelf.querySelectorAll(".".concat(common_constants_1.BcCommonConstants.INPUT_TAG, "[name=").concat(key, "]"));
        if (objData.length && objData[bc_search_constants_21.SEARCH_NUMBER_ZERO].dataset.value) {
            booleanResult = String(user[objData[bc_search_constants_21.SEARCH_NUMBER_ZERO].dataset.value])
                .toUpperCase()
                .includes(filter[key].toUpperCase());
            if (!booleanResult) {
                booleanResult = String(user[key]).toUpperCase().includes(filter[key].toUpperCase());
            }
        }
        else {
            if (user[key] && filter[key]) {
                var currentProperties = [];
                for (var keyFilter in filter) {
                    currentProperties = currentProperties.concat(keyFilter);
                    if (currentProperties.length > 1) {
                        var filterSeveralInputs = [];
                        for (var index = 0; index < currentProperties.length; index++) {
                            filterSeveralInputs = filterSeveralInputs.concat(this.searchDataInput(user, currentProperties, filter, index));
                            booleanResult = !filterSeveralInputs.includes(false);
                        }
                    }
                    else {
                        booleanResult = this.searchDataInput(user, currentProperties, filter, 0);
                    }
                }
            }
        }
        return booleanResult;
    };
    BcSearchBehavior.prototype.searchDataInput = function (user, currentProperties, filter, position) {
        var filterData = filter[currentProperties[position]];
        return typeof (filterData) === 'string'
            ? String(user[currentProperties[position]]).toUpperCase().includes(filterData.toUpperCase())
            : String(filterData).toUpperCase().includes(user[currentProperties[position]].toUpperCase());
    };
    BcSearchBehavior.prototype.setValueInput = function (jsObjt) {
        this.keyObjtValue = jsObjt;
        return this.keyObjtValue;
    };
    BcSearchBehavior.prototype.setInputSelectInSearch = function () {
        var _this = this;
        var selectElement = this.mySelf.querySelectorAll(common_constants_1.BcCommonConstants.DIV_TAG);
        for (var _i = 0, selectElement_1 = selectElement; _i < selectElement_1.length; _i++) {
            var div = selectElement_1[_i];
            if (div.classList.contains("".concat(bc_search_constants_11.SEARCH_INPUT_SELECT_CLASS))) {
                var selectComponent = new bc_input_select_behavior_1.BcInputSelectBehavior();
                selectComponent.setElement(div);
                selectComponent.outputFunction = function () {
                    _this.searchObject();
                };
                selectComponent.setUp();
            }
        }
    };
    BcSearchBehavior.prototype.showQuantityItems = function (value) {
        var result = this.mySelf.querySelector(".".concat(bc_search_constants_12.SEARCH_CONTENT_SHOW_RESULT_CLASS));
        var clearSelector = this.mySelf.querySelector(".".concat(bc_search_constants_14.SEARCH_CLEAR_CLASS));
        var divAttributes = this.mySelf.querySelectorAll(".".concat(bc_search_constants_15.SEARCH_RESULT_NULL_CLASS, " ").concat(common_constants_1.BcCommonConstants.DIV_TAG));
        var text;
        if (value === common_constants_1.BcCommonConstants.UNDEFINED) {
            while (result.firstChild) {
                result.removeChild(result.firstChild);
            }
            clearSelector.classList.remove("".concat(bc_search_constants_16.SEARCH_CLEAR_SHOW_CLASS));
        }
        else if (value) {
            text = "Mostrando ".concat(value, " resultados para: ").concat(this.stringFilters);
            this.changeTextResult(result, text, clearSelector);
        }
        else {
            text = "Mostrando 0 resultados para: ".concat(this.stringFilters, " ");
            this.changeTextResult(result, text, clearSelector);
        }
        this.removeOrAddAtributesDiv(value, divAttributes);
    };
    BcSearchBehavior.prototype.removeOrAddAtributesDiv = function (value, divAttributes) {
        if (!value) {
            for (var _i = 0, divAttributes_2 = divAttributes; _i < divAttributes_2.length; _i++) {
                var divAttribute = divAttributes_2[_i];
                divAttribute.classList.add("".concat(bc_search_constants_17.SEARCH_SHOW_IMAGE_CLASS));
            }
        }
        else {
            this.removeDivAttributeImage(divAttributes);
        }
    };
    BcSearchBehavior.prototype.changeTextResult = function (result, text, clearSelector) {
        var span = document.createElement(bc_search_constants_7.SEARCH_SPAN);
        while (result.firstChild) {
            result.removeChild(result.firstChild);
        }
        span.textContent = text;
        result.appendChild(span);
        clearSelector.classList.add("".concat(bc_search_constants_16.SEARCH_CLEAR_SHOW_CLASS));
    };
    BcSearchBehavior.prototype.clearSearch = function () {
        var _this = this;
        var result = this.mySelf.querySelector(".".concat(bc_search_constants_12.SEARCH_CONTENT_SHOW_RESULT_CLASS));
        var linkClean = this.mySelf.querySelector(".".concat(bc_search_constants_14.SEARCH_CLEAR_CLASS));
        var divAttributes = this.mySelf.querySelectorAll(".".concat(bc_search_constants_15.SEARCH_RESULT_NULL_CLASS, " ").concat(common_constants_1.BcCommonConstants.DIV_TAG));
        linkClean &&
            linkClean.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function () {
                _this.cleanValidation(result, linkClean, divAttributes);
            });
        (0, helpers_1.addFocusable)(linkClean, { tabindex: '0' });
        linkClean &&
            linkClean.addEventListener(common_constants_1.BcCommonConstants.EVENT_KEY_UP, function (event) {
                if (event.key === common_constants_1.BcCommonConstants.KEY_EVENT_SPACE ||
                    event.key === common_constants_1.BcCommonConstants.KEY_EVENT_ENTER ||
                    event.key === ' ') {
                    _this.cleanValidation(result, linkClean, divAttributes);
                }
            });
    };
    BcSearchBehavior.prototype.clearSearchOutput = function () {
        var _this = this;
        var result = this.mySelf.querySelector(".".concat(bc_search_constants_12.SEARCH_CONTENT_SHOW_RESULT_CLASS));
        var linkClean = this.mySelf.querySelector(".".concat(bc_search_constants_14.SEARCH_CLEAR_CLASS));
        var divAttributes = this.mySelf.querySelectorAll(".".concat(bc_search_constants_15.SEARCH_RESULT_NULL_CLASS, " ").concat(common_constants_1.BcCommonConstants.DIV_TAG));
        linkClean &&
            linkClean.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function () {
                _this.cleanValidation(result, linkClean, divAttributes);
                _this.outputFunctionClear(new CustomEvent('clearsearch', {
                    detail: _this.objectArrayItem
                }));
            });
    };
    BcSearchBehavior.prototype.cleanValidationSearch = function () {
        var result = this.mySelf.querySelector(".".concat(bc_search_constants_12.SEARCH_CONTENT_SHOW_RESULT_CLASS));
        var linkClean = this.mySelf.querySelector(".".concat(bc_search_constants_14.SEARCH_CLEAR_CLASS));
        var divAttributes = this.mySelf.querySelectorAll(".".concat(bc_search_constants_15.SEARCH_RESULT_NULL_CLASS, " ").concat(common_constants_1.BcCommonConstants.DIV_TAG));
        this.cleanValidation(result, linkClean, divAttributes);
        this.outputFunctionClear(new CustomEvent('clearsearch', {
            detail: this.objectArrayItem
        }));
    };
    BcSearchBehavior.prototype.cleanValidation = function (result, linkClean, divAttributes) {
        this.jsObjt = {};
        this.jsDates = {};
        this.jsRangeData = {};
        this.jsSelectMultiple = {};
        var inputValues = this.mySelf.querySelectorAll("".concat(common_constants_1.BcCommonConstants.INPUT_TAG));
        var buttonSearch = this.mySelf.querySelector(".".concat(bc_search_constants_10.SEARCH_BUTTON_CLASS, " ").concat(common_constants_1.BcCommonConstants.BUTTON_TAG));
        var checkElement = this.mySelf.querySelectorAll("".concat(common_constants_1.BcCommonConstants.EM_TAG));
        while (result.firstChild) {
            result.removeChild(result.firstChild);
        }
        linkClean.classList.remove("".concat(bc_search_constants_16.SEARCH_CLEAR_SHOW_CLASS));
        buttonSearch.disabled = common_constants_1.BcCommonConstants.TRUE;
        for (var _i = 0, inputValues_1 = inputValues; _i < inputValues_1.length; _i++) {
            var inputValue = inputValues_1[_i];
            if (inputValue.type === bc_search_constants_8.SEARCH_INPUT_CHECKBOX && inputValue.className !== "".concat(bc_search_constants_1.SEARCH_INPUT_SELECT_MULTIPLE_ITEM_CLASS)) {
                this.cleanInputsCheckSearch(inputValue);
            }
            else {
                if (inputValue.value) {
                    this.cleanInputsSearch(inputValue);
                }
            }
        }
        checkElement.forEach(function (item) {
            if (item && item.innerHTML == 'ok') {
                item.remove();
            }
        });
        this.removeDivAttributeImage(divAttributes);
        this.resultFilter = [];
    };
    BcSearchBehavior.prototype.cleanInputsCheckSearch = function (inputValue) {
        if (inputValue.checked) {
            inputValue.checked = common_constants_1.BcCommonConstants.FALSE;
        }
    };
    BcSearchBehavior.prototype.cleanInputsSearch = function (inputValue) {
        for (var _i = 0, _a = inputValue.classList; _i < _a.length; _i++) {
            var classInput = _a[_i];
            if (classInput == "".concat(bc_search_constants_22.INPUT_ACTIVE_SEARCH_CLASS)) {
                inputValue.classList.remove("".concat(bc_search_constants_22.INPUT_ACTIVE_SEARCH_CLASS));
            }
        }
        for (var i = 0; i < inputValue.length; i++) {
            if (inputValue.options[i].value) {
                inputValue.remove(i);
            }
        }
        inputValue.value = '';
    };
    BcSearchBehavior.prototype.hideElements = function () {
        var _this = this;
        this.resizeSettings();
        window.addEventListener(common_constants_1.BcCommonConstants.EVENT_RESIZE, function () {
            _this.resizeSettings();
        });
    };
    BcSearchBehavior.prototype.resizeSettings = function () {
        var widthPage = window.innerWidth;
        var contentInputsBase = this.mySelf.querySelector(".".concat(bc_search_constants_3.SEARCH_CONTENT));
        var searchIconLupa = contentInputsBase.querySelector(".".concat(bc_search_constants_10.SEARCH_BUTTON_CLASS));
        var contentInputs = contentInputsBase.querySelectorAll(":scope > ".concat(common_constants_1.BcCommonConstants.DIV_TAG, "[class*=\"").concat(bc_search_constants_4.SEARCH_INPUTS, "\"], :scope >*> ").concat(common_constants_1.BcCommonConstants.DIV_TAG, "[class*=\"").concat(bc_search_constants_4.SEARCH_INPUTS, "\"]"));
        var contentAdvanceSearch = this.mySelf.querySelector(".".concat(bc_search_constants_18.SEARCH_ADVANCED_CLASS));
        var contentAdvancedMobile = contentAdvanceSearch.querySelector("".concat(common_constants_1.BcCommonConstants.DIV_TAG, "[class=\"").concat(bc_search_constants_2.SEARCH_CONTENT_FORM, "\"]"));
        if (widthPage <= bc_search_constants_6.SEARCH_NUMBER_BREAKPOINT_MD) {
            this.createCloneInput(contentInputs, contentAdvancedMobile);
        }
        else {
            this.deleteCloneInput(contentAdvancedMobile, searchIconLupa);
        }
    };
    BcSearchBehavior.prototype.createCloneInput = function (contentInputs, contentAdvancedMobile) {
        var _this = this;
        contentInputs.forEach(function (element1, index) {
            if (index > bc_search_constants_21.SEARCH_NUMBER_ZERO) {
                var parentNodes = element1.parentNode;
                _this.inputsContentsMemory.push({
                    element: element1,
                    parent: parentNodes,
                });
                parentNodes.removeChild(element1);
                contentAdvancedMobile === null || contentAdvancedMobile === void 0 ? void 0 : contentAdvancedMobile.appendChild(element1);
            }
        });
    };
    BcSearchBehavior.prototype.deleteCloneInput = function (contentAdvancedMobile, searchIconLupa) {
        var tempInpustMemoryCopy = __spreadArray([], this.inputsContentsMemory, true);
        for (var i = bc_search_constants_21.SEARCH_NUMBER_ZERO; i < tempInpustMemoryCopy.length; i++) {
            var elementContent = tempInpustMemoryCopy[i];
            contentAdvancedMobile === null || contentAdvancedMobile === void 0 ? void 0 : contentAdvancedMobile.removeChild(elementContent.element);
            this.inputsContentsMemory.splice(i, 1);
            if (!!searchIconLupa) {
                if (searchIconLupa.parentNode == elementContent.parent) {
                    elementContent.parent.insertBefore(elementContent.element, searchIconLupa);
                }
                else {
                    elementContent.parent.appendChild(elementContent.element);
                }
            }
        }
    };
    BcSearchBehavior.prototype.initInputBehavior = function () {
        var inputs = this.mySelf.querySelectorAll(common_constants_1.BcCommonConstants.INPUT_TAG);
        for (var i = bc_search_constants_21.SEARCH_NUMBER_ZERO; i < inputs.length; i++) {
            this.inputBehavior = new bc_input_behavior_1.BcInputBehavior();
            var element = inputs[i];
            this.inputBehavior.setElement(element);
            this.inputBehavior.setUp();
        }
    };
    return BcSearchBehavior;
}(default_behavior_1.BcDefaultBehavior));
exports.BcSearchBehavior = BcSearchBehavior;
